import gql from 'graphql-tag';

const REMOVE_CLASSROOM = gql`
  mutation removeClassroom($classroomId: Int!) {
    removeClassroom(where: { id: $classroomId }) {
      id
      dateRemoved
    }
  }
`;

export default REMOVE_CLASSROOM;
